import { render, staticRenderFns } from "./orderEditAddress.vue?vue&type=template&id=0d071732&scoped=true&"
import script from "./orderEditAddress.vue?vue&type=script&lang=js&"
export * from "./orderEditAddress.vue?vue&type=script&lang=js&"
import style0 from "./orderEditAddress.vue?vue&type=style&index=0&id=0d071732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d071732",
  null
  
)

export default component.exports